'use client';

import type { InsuranceProvider } from '@//app/api/commerce/insurance/provider/[id]';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Button } from '@//components/Button';
import { TextContentHtml } from '@//components/TextContent';
import { useLegacyTrackInsuranceInterested } from '@//data/tracking/useLegacyTrackInsuranceInterested';
import { markdownToHtml } from '@//utils/text';
import { WidgetHeading } from '../../WidgetHeading';

interface InsuranceSimpleProps {
  insuranceProvider: InsuranceProvider;
  vehicle: ElasticVehicle;
}

export const InsuranceSimple: React.FC<InsuranceSimpleProps> = ({ insuranceProvider, vehicle }) => {
  const { trackLegacyInsuranceInterested } = useLegacyTrackInsuranceInterested();

  const handleClick = () => {
    trackLegacyInsuranceInterested({
      vehicle,
      information: {
        drivingRange: '',
        identifier: insuranceProvider.identifier,
        institute: insuranceProvider.institute,
      },
    });
  };

  return (
    <>
      {insuranceProvider.logo && (
        <img
          src={`${insuranceProvider.logo}?w=80&h=40`}
          srcSet={`${insuranceProvider.logo}?w=160&h=80 2x`}
          style={{ maxWidth: '80px' }}
          alt={insuranceProvider.title}
          fetchPriority="low"
        />
      )}
      <WidgetHeading>{insuranceProvider.title}</WidgetHeading>
      <TextContentHtml textSize="md" html={markdownToHtml(insuranceProvider.description)} />
      {insuranceProvider.url && (
        <Button
          variant="secondary"
          href={insuranceProvider.url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={handleClick}
          prefetch="none"
        >
          Läs mer
        </Button>
      )}
    </>
  );
};
